
/**
 * Cookie token defintions.
 */

const TOKEN_LABEL = "token";
const REFRESH_TOKEN_LABEL = "refresh";
const ONBOARDING_TOKEN_LABEL = "onboarding-token";
const CSS_TOKEN_LABEL = "css-token";

const TOKEN_EXPIRY_MINUTES = 20 * 60; // 20 hours

const jwt = require("jsonwebtoken");

const env = process.env.RAZZLE_ENV || process.env.NODE_ENV || "development";
const config = require("../server/config/config.json")[env];

/**
 * @param data: Data to encode
 * @param label: cookie identifies
 * @param res: HttpResponse to write to.
 */
let setToken = (data, label, res) => {
  const token = jwt.sign(
    data,
    config.JWT_SECRET,
    {
      expiresIn: TOKEN_EXPIRY_MINUTES * 60, // seconds
    });
  res.set(label, token);
  res.cookie(label, token, {
    httpOnly: true,
    maxAge: TOKEN_EXPIRY_MINUTES * 60 * 1000, // milli-seconds
  });
};

export { ONBOARDING_TOKEN_LABEL, CSS_TOKEN_LABEL, TOKEN_EXPIRY_MINUTES,
  TOKEN_LABEL, REFRESH_TOKEN_LABEL, setToken };

